export class AuthConstant {
    public static readonly TOKEN_TYPE_KEY = "Bearer ";
    public static readonly ACCESS_TOKEN = "access_token";
    public static readonly REMEMBER_LOGIN = "remember";
    public static readonly EXPIRES_REMEMBER = 365; //day
    public static readonly EXPIRES_TOKEN = 1;
}
